import Modifier from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';
import { scheduleOnce, cancel } from '@ember/runloop';

const cleanup = (instance) => {
  cancel(instance.timeout);
  instance.element?.removeEventListener(instance.handleChange);
};

class ShSelectModifier extends Modifier {
  element = null;
  timeout = null;
  onChange = null;
  selectedIndex = -1;

  handleChange = (e) => {
    this.onChange?.(e.target.value);
    this.element.selectedIndex = this.selectedIndex;
  };

  constructor() {
    super(...arguments);
    registerDestructor(this, cleanup);
  }

  modify(element, [selectedIndex, onChange]) {
    this.selectedIndex = selectedIndex;
    this.onChange = onChange;

    if (!this.element) {
      this.element = element;
      this.element.addEventListener('change', this.handleChange);
    }

    this.timeout = scheduleOnce(
      'afterRender',
      this,
      this.setSelectedOption,
    );
  }

  setSelectedOption() {
    this.timeout = null;
    this.element.selectedIndex = this.selectedIndex;
  }
}

export default ShSelectModifier;
